const getConfig = environment => {
  const env = process.env.CYPRESS_STANDALONE || window.Cypress ? 'test' : environment;

  const config = {
    env,
    backendUrl: '',
    datadogAppId: '3bc982e1-a756-4d6d-ae42-746b5a2750a0',
    datadogClientToken: 'pub19038efc64c0b6116983bbd474488eba',
  };

  switch (env) {
    case 'development':
      config.backendUrl = 'http://app.salonized.fml:3000/api'
      break;
    case 'test':
      config.backendUrl = 'http://test.salonized.fml:3000/api'
      break;
    case 'staging':
    case 'production':
      config.backendUrl = process.env.VUE_APP_BACKEND_URL + '/api'
      break;
    }

  return config;
}

export default Object.freeze(getConfig(process.env.VUE_APP_ENV));
